const normalizePaymentToken = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const isCashPaymentEntry = (entry, configuredMethods = []) => {
  const rawMethod =
    entry?.methodId ?? entry?.method ?? entry?.code ?? entry?.name ?? "";
  const token = normalizePaymentToken(rawMethod);
  const configured = (configuredMethods || []).find((method) =>
    [method?.id, method?.code, method?.name]
      .map(normalizePaymentToken)
      .filter(Boolean)
      .includes(token),
  );
  const candidates = [rawMethod, configured?.code, configured?.name]
    .map(normalizePaymentToken)
    .filter(Boolean);
  return candidates.some(
    (candidate) =>
      candidate === "cash" ||
      candidate === "espece" ||
      candidate === "especes" ||
      candidate.includes("espece"),
  );
};

export const buildNetPaymentBreakdown = (
  entries = [],
  changeGiven = 0,
  configuredMethods = [],
) => {
  let remainingChange = Math.max(0, Number(changeGiven) || 0);
  return (Array.isArray(entries) ? entries : []).map((entry) => {
    const amount = Math.max(0, Number(entry?.amount) || 0);
    if (!isCashPaymentEntry(entry, configuredMethods) || remainingChange <= 0) {
      return { ...entry, amount };
    }
    const appliedChange = Math.min(amount, remainingChange);
    remainingChange = Math.max(0, remainingChange - appliedChange);
    return { ...entry, amount: Math.max(0, amount - appliedChange) };
  });
};

export { isCashPaymentEntry };
